module.exports = __webpack_public_path__ + "media/svg/is-bb2810ef.svg";